
import {map} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PhoenixProcessingState } from "../../models/phoenix/phoenix.processing-state.model";
import { UserService } from "../shared/user.service";
import { BasicData } from "../../models/phoenix/phoenix.basic-data.model";
import { PhoenixRequestDetails } from "../../models/phoenix/phoenix.request-details.model";
import { FunctionUsageService } from "@app/services/functioninfo/functionUsage.service";
import { FileBase64Response } from "@app/models/shared/fileBase64Response.model";

@Injectable({ providedIn: "root" })
export class PhoenixService {

  public service = 'PhoenixService';

  constructor(public http: HttpClient,
    public userService: UserService,
    public functionUsageService: FunctionUsageService) {
  }

  public createBasicData(postObject: BasicData) {
    this.functionUsageService.updateFunctionUsage(postObject.discipline, postObject.functionCode);

    return this.http.post(`api/${this.service}/CreateBasicData`,
      JSON.stringify(postObject),
      { responseType: "json" });
  };

  public createPhoenixRequestDetails(postObject: PhoenixRequestDetails) {
    return this.http.post(`api/${this.service}/CreatePhoenixRequestDetails`,
      JSON.stringify(postObject),
      { responseType: "text" });
  };

  public checkFileProcessState(searchQuery) {
    return this.http.get<PhoenixProcessingState>(`api/${this.service}/CheckFileProcessState`, { params: searchQuery });
  };

  public checkFileProcessStateFromFileSystem(searchQuery) {
    const options = { params: searchQuery };

    return this.http.get<FileBase64Response>(`api/${this.service}/CheckFileProcessStateFromFileSystem`, options).pipe(
      map(res =>
        (
          {
            content: res != null ? res.base64FileContent : '',
            fileName: res != null ? res.fileName : '',
            mimeType: res != null ? res.mimeType : '',
            isStreamingResult: res != null ? res.isStreamingResult : null
          }
        )));
  };

  public getDestinationPathOfBasicData(id) {
    return this.http.get<PhoenixProcessingState>(`api/${this.service}/GetDestinationPathOfBasicData`, { params: id });
  };
}
